import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import * as MessageActions from '../../common/messageBox/actions/actions';

export const fetchAnticipatedInvoiceVehiclesList = () => apiActionCreator({
  'endpoint': '/anticipated-invoice/candidates',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_ANTICIPATED_INVOICE_VEHICLES_LIST,
    ActionTypes.FETCHED_ANTICIPATED_INVOICE_VEHICLES_LIST,
    [ActionTypes.FETCHED_ANTICIPATED_INVOICE_VEHICLES_LIST_FAILED, (error) => buildErrorMessage(error)],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const restoreTasksValidationValue = () => ({
  'type': ActionTypes.RESTORE_TASKS_VALIDATION_VALUE,
});

export const saveAnticipatedInvoiceVehiclesList = (data) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/anticipated-invoice/candidates',
    'authenticated': true,
    'types': [
      ActionTypes.SAVING_ANTICIPATED_INVOICE_VEHICLES_LIST,
      [
        () => {
          dispatch(fetchAnticipatedInvoiceVehiclesList());
          return {'type': ActionTypes.SAVED_ANTICIPATED_INVOICE_VEHICLES_LIST};
        },
        MessageActions
          .addMessageBoxInfo('Los vehículos para facturación anticipada fueron actualizados correctamente.'),
      ],
      [
        ActionTypes.SAVED_ANTICIPATED_INVOICE_VEHICLES_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    data,
  }));
};

export const notificateAnticipatedInvoiceVehiclesList = (data) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/anticipated-invoice/candidates/notification',
    'authenticated': true,
    'types': [
      ActionTypes.NOTIFICATING_ANTICIPATED_INVOICE_VEHICLES_LIST,
      [
        () => {
          dispatch(fetchAnticipatedInvoiceVehiclesList());
          return {'type': ActionTypes.NOTIFICATED_ANTICIPATED_INVOICE_VEHICLES_LIST};
        },
        MessageActions
          .addMessageBoxInfo('Los notificación ha sido enviada con éxito.'),
      ],
      [
        ActionTypes.NOTIFICATED_ANTICIPATED_INVOICE_VEHICLES_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    data,
  }));
};
